import React from 'react';
import { useQuery } from 'react-apollo-hooks';
import { groupMembersQuery } from '../../queries/groups';
import { subjectMembersQuery } from '../../queries/subjects';
import MemberAvatar from '../ui/MemberAvatar';
import { MembersProps } from './types';
import styled from 'styled-components';
import { variables } from '../utils';

interface Member {
  id: string;
  member: {
    id: string;
    displayName: string;
    user: {
      avatarUrl: string;
    };
  };
}

const Avatar = styled.div.attrs({
  className: 'mr1-ns mt1-ns'
})`
  @media (max-width: ${variables.medium}px) {
    position: absolute;
    top: 0;
    right: ${(p: { index: number }) => p.index * 4}px;
  }
`;

const Members: React.FC<MembersProps> = ({ item }) => {
  const memberQuery = item.type === 'GROUP' ? groupMembersQuery : subjectMembersQuery;
  const memberQueryVariables =
    item.type === 'GROUP' ? { groupId: item.id } : { subjectId: item.id };

  const { data, loading } = useQuery(memberQuery, {
    variables: { input: { ...memberQueryVariables } }
  });

  if (loading) return <div />;

  const members: Member[] | null = item.type === 'GROUP' ? data.groupMembers : data.subjectMembers;

  return (
    <>
      {members && members.length > 1 && (
        <div className="relative flex-ns flex-wrap-ns" style={{ minHeight: 23 }}>
          {members.map(({ id, member }, index) => (
            <Avatar key={id} index={index}>
              <MemberAvatar member={member} key={id} />
            </Avatar>
          ))}
        </div>
      )}
    </>
  );
};

export default Members;
